import { render, staticRenderFns } from "./basicDataSummary.vue?vue&type=template&id=5aacbbca&"
import script from "./basicDataSummary.vue?vue&type=script&lang=js&"
export * from "./basicDataSummary.vue?vue&type=script&lang=js&"
import style0 from "./basicDataSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports